// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/tradable_area_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/tradable_area_service.proto.
 */
export const file_bffuser_v1_tradable_area_service: GenFile = /*@__PURE__*/
  fileDesc("CiZiZmZ1c2VyL3YxL3RyYWRhYmxlX2FyZWFfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSJEChhMaXN0VHJhZGFibGVBcmVhc1JlcXVlc3QSKAoNZGVsaXZlcnlfZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUipwIKGUxpc3RUcmFkYWJsZUFyZWFzUmVzcG9uc2USLQoOdHJhZGFibGVfYXJlYXMYASADKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRInCh9kZWxpdmVyeV9jb250cmFjdF9jaGVja19za2lwcGVkGAIgASgIEi8KB2lzc3VlcnMYAyADKAsyHi5iZmZ1c2VyLnYxLlRyYWRhYmxlQXJlYUlzc3VlchI5ChdyZWdpc3RlcmVkX2lzc3Vlcl90eXBlcxgEIAMoDjIYLmJmZnR5cGVzLnYxLkxpY2Vuc2VUeXBlEkYKE3JlZ2lzdHJhdGlvbl9pc3N1ZXMYBSADKAsyKS5iZmZ1c2VyLnYxLlRyYWRhYmxlQXJlYVJlZ2lzdHJhdGlvbklzc3VlItICCh1UcmFkYWJsZUFyZWFSZWdpc3RyYXRpb25Jc3N1ZRItCgtpc3N1ZXJfdHlwZRgBIAEoDjIYLmJmZnR5cGVzLnYxLkxpY2Vuc2VUeXBlEiMKBGFyZWEYAiABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRJPCg5taXNzaW5nX21hc3RlchgDIAEoDjI3LmJmZnVzZXIudjEuVHJhZGFibGVBcmVhUmVnaXN0cmF0aW9uSXNzdWUuTWlzc2luZ01hc3RlciKLAQoNTWlzc2luZ01hc3RlchIeChpNSVNTSU5HX01BU1RFUl9VTlNQRUNJRklFRBAAEhwKGE1JU1NJTkdfTUFTVEVSX1NVQk1JVFRFUhABEiUKIU1JU1NJTkdfTUFTVEVSX0RFTUFORF9QUk9DVVJFTUVOVBACEhUKEU1JU1NJTkdfTUFTVEVSX0JHEAMisgEKElRyYWRhYmxlQXJlYUlzc3VlchItCgtpc3N1ZXJfdHlwZRgBIAEoDjIYLmJmZnR5cGVzLnYxLkxpY2Vuc2VUeXBlEj4KEHJlZ2lzdGVyZWRfYXJlYXMYAiADKAsyJC5iZmZ1c2VyLnYxLlRyYWRhYmxlQXJlYUNvbnRyYWN0Q29kZRItCg50cmFkYWJsZV9hcmVhcxgDIAMoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlIl8KGFRyYWRhYmxlQXJlYUNvbnRyYWN0Q29kZRIjCgRhcmVhGAEgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGUSHgoWZGVsaXZlcnlfY29udHJhY3RfY29kZRgCIAEoCTJ5ChNUcmFkYWJsZUFyZWFTZXJ2aWNlEmIKEUxpc3RUcmFkYWJsZUFyZWFzEiQuYmZmdXNlci52MS5MaXN0VHJhZGFibGVBcmVhc1JlcXVlc3QaJS5iZmZ1c2VyLnYxLkxpc3RUcmFkYWJsZUFyZWFzUmVzcG9uc2UiAEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListTradableAreasRequest
 */
export type ListTradableAreasRequest = Message<"bffuser.v1.ListTradableAreasRequest"> & {
  /**
   * delivery_date is the 受渡日 the OCCTO masters are evaluated on. Unset
   * means the backend's business date (JST today).
   *
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;
};

/**
 * Describes the message bffuser.v1.ListTradableAreasRequest.
 * Use `create(ListTradableAreasRequestSchema)` to create a new message.
 */
export const ListTradableAreasRequestSchema: GenMessage<ListTradableAreasRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_tradable_area_service, 0);

/**
 * @generated from message bffuser.v1.ListTradableAreasResponse
 */
export type ListTradableAreasResponse = Message<"bffuser.v1.ListTradableAreasResponse"> & {
  /**
   * tradable_areas is the union of issuers[].tradable_areas, sorted
   * ascending. Areas outside the JEPX trading scope (沖縄) are never included.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode tradable_areas = 1;
   */
  tradableAreas: AreaCode[];

  /**
   * delivery_contract_check_skipped is true when the 受渡契約コード condition
   * could not be evaluated (pikopiko-config unreachable), so every
   * tradable_areas list is computed without it. An area in a degraded list may
   * nonetheless fail at submission time.
   *
   * @generated from field: bool delivery_contract_check_skipped = 2;
   */
  deliveryContractCheckSkipped: boolean;

  /**
   * issuers lists, per 発注主体区分 (需要BG / 発電 / 自己託送BG), the areas
   * registered for it on delivery_date (registered_areas) and the subset the
   * user can pick (tradable_areas). An issuer type is included when at least
   * one area's 受渡契約コード resolves for it (= registered), even if none of
   * its areas is tradable; an issuer type with no such area is omitted
   * (AC-BSP-005d / AC-BIN-004). Without JEPX 会員情報 no 発電 code resolves
   * (AC-IJM-010), yet 発電 is included when a 計画提出者 of a 自社の事業者 is
   * registered (AC-BSP-105 (c) / AC-BIN-111 (c)). Sorted by issuer_type
   * ascending; the display priority is the frontend's.
   *
   * @generated from field: repeated bffuser.v1.TradableAreaIssuer issuers = 3;
   */
  issuers: TradableAreaIssuer[];

  /**
   * registered_issuer_types is the common-toolbar registration list, sorted
   * ascending without duplicates. Unlike issuers, it does not depend on
   * delivery_date, JEPX membership or configured delivery contracts.
   * It includes own-business BG / generation-submitter registrations only;
   * battery BGs and non-issuer license types are excluded (AC-BSP-135).
   *
   * @generated from field: repeated bfftypes.v1.LicenseType registered_issuer_types = 4;
   */
  registeredIssuerTypes: LicenseType[];

  /**
   * @generated from field: repeated bffuser.v1.TradableAreaRegistrationIssue registration_issues = 5;
   */
  registrationIssues: TradableAreaRegistrationIssue[];
};

/**
 * Describes the message bffuser.v1.ListTradableAreasResponse.
 * Use `create(ListTradableAreasResponseSchema)` to create a new message.
 */
export const ListTradableAreasResponseSchema: GenMessage<ListTradableAreasResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_tradable_area_service, 1);

/**
 * TradableAreaRegistrationIssue explains why an issuer/area pair is not registered.
 *
 * @generated from message bffuser.v1.TradableAreaRegistrationIssue
 */
export type TradableAreaRegistrationIssue = Message<"bffuser.v1.TradableAreaRegistrationIssue"> & {
  /**
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 1;
   */
  issuerType: LicenseType;

  /**
   * @generated from field: bfftypes.v1.AreaCode area = 2;
   */
  area: AreaCode;

  /**
   * @generated from field: bffuser.v1.TradableAreaRegistrationIssue.MissingMaster missing_master = 3;
   */
  missingMaster: TradableAreaRegistrationIssue_MissingMaster;
};

/**
 * Describes the message bffuser.v1.TradableAreaRegistrationIssue.
 * Use `create(TradableAreaRegistrationIssueSchema)` to create a new message.
 */
export const TradableAreaRegistrationIssueSchema: GenMessage<TradableAreaRegistrationIssue> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_tradable_area_service, 2);

/**
 * @generated from enum bffuser.v1.TradableAreaRegistrationIssue.MissingMaster
 */
export enum TradableAreaRegistrationIssue_MissingMaster {
  /**
   * @generated from enum value: MISSING_MASTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MISSING_MASTER_SUBMITTER = 1;
   */
  SUBMITTER = 1,

  /**
   * @generated from enum value: MISSING_MASTER_DEMAND_PROCUREMENT = 2;
   */
  DEMAND_PROCUREMENT = 2,

  /**
   * @generated from enum value: MISSING_MASTER_BG = 3;
   */
  BG = 3,
}

/**
 * Describes the enum bffuser.v1.TradableAreaRegistrationIssue.MissingMaster.
 */
export const TradableAreaRegistrationIssue_MissingMasterSchema: GenEnum<TradableAreaRegistrationIssue_MissingMaster> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_tradable_area_service, 2, 0);

/**
 * TradableAreaIssuer is one 発注主体区分's areas in ListTradableAreasResponse.
 *
 * @generated from message bffuser.v1.TradableAreaIssuer
 */
export type TradableAreaIssuer = Message<"bffuser.v1.TradableAreaIssuer"> & {
  /**
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 1;
   */
  issuerType: LicenseType;

  /**
   * registered_areas are the areas whose 受渡契約コード resolves for this
   * issuer type on delivery_date (= registered in the OCCTO masters; may
   * include 沖縄), with the resolved code, sorted by area ascending. 発電 of
   * an organization without JEPX 会員情報 has the areas of its 自社の事業者's
   * 計画提出者 here with an empty delivery_contract_code (not derived without
   * 会員情報, AC-IJM-010).
   *
   * @generated from field: repeated bffuser.v1.TradableAreaContractCode registered_areas = 2;
   */
  registeredAreas: TradableAreaContractCode[];

  /**
   * tradable_areas are the registered_areas the user can pick (within the
   * JEPX trading scope, with a 受渡契約コード in pikopiko-config unless
   * delivery_contract_check_skipped). Empty for an organization without JEPX
   * 会員情報. Sorted ascending.
   *
   * @generated from field: repeated bfftypes.v1.AreaCode tradable_areas = 3;
   */
  tradableAreas: AreaCode[];
};

/**
 * Describes the message bffuser.v1.TradableAreaIssuer.
 * Use `create(TradableAreaIssuerSchema)` to create a new message.
 */
export const TradableAreaIssuerSchema: GenMessage<TradableAreaIssuer> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_tradable_area_service, 3);

/**
 * TradableAreaContractCode is a 受渡契約コード resolved for an area.
 *
 * @generated from message bffuser.v1.TradableAreaContractCode
 */
export type TradableAreaContractCode = Message<"bffuser.v1.TradableAreaContractCode"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area = 1;
   */
  area: AreaCode;

  /**
   * @generated from field: string delivery_contract_code = 2;
   */
  deliveryContractCode: string;
};

/**
 * Describes the message bffuser.v1.TradableAreaContractCode.
 * Use `create(TradableAreaContractCodeSchema)` to create a new message.
 */
export const TradableAreaContractCodeSchema: GenMessage<TradableAreaContractCode> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_tradable_area_service, 4);

/**
 * TradableAreaService provides Connect RPCs for retrieving the electricity
 * areas in which the authenticated organization can place a JEPX bid, per
 * 発注主体区分 (issuer type), as of a 受渡日.
 *
 * @generated from service bffuser.v1.TradableAreaService
 */
export const TradableAreaService: GenService<{
  /**
   * ListTradableAreas returns, for each 発注主体区分, the areas whose
   * 受渡契約コード resolves from the organization's OCCTO masters on the
   * 受渡日, and the subset the bidding screens let the user pick. The bidding
   * screens build the 発注主体 selector and gate per-area actions from it.
   *
   * @generated from rpc bffuser.v1.TradableAreaService.ListTradableAreas
   */
  listTradableAreas: {
    methodKind: "unary";
    input: typeof ListTradableAreasRequestSchema;
    output: typeof ListTradableAreasResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_tradable_area_service, 0);

